import * as React from 'react';
import classNames from 'classnames';
import {NOOP} from 'components/UIKit/utilities';
import {Flex, Icon} from 'components/UIKit';
import styles from './ViewToggleButtons.scss';

interface ViewToggleButtonsProps {
  activeView: 'image' | 'graph';
  onToggleClick: () => any;
}

export function ViewToggleButtons({
  activeView = 'image',
  onToggleClick = NOOP,
}: ViewToggleButtonsProps) {
  const imageVisible: boolean = activeView === 'image';

  return (
    <Flex justifyContent="flex-end" className={styles.Container}>
      <Icon
        icon="imageView"
        className={classNames(styles.IconButton, {[styles.Active]: imageVisible})}
        size={16}
        onClick={onToggleClick}
        asButton
        aria-label="toggle listing image"
        aria-pressed={imageVisible}
      />
      <Icon
        icon="graphView"
        className={classNames(styles.IconButton, {[styles.Active]: !imageVisible})}
        size={16}
        onClick={onToggleClick}
        asButton
        aria-label="toggle revenue graph"
        aria-pressed={!imageVisible}
      />
    </Flex>
  );
}
